import React, { useState } from 'react';
import { Button, ConfirmModal, ButtonHierarchies } from '@clockout-dev/design-elements';
import styles from './styles/form.module.scss';
import { DEFAULT_CONFIRM_TITLE, DEFAULT_CONFIRM_MESSAGE } from './form.constants';
import HasScope from '../hasScope/HasScope';

export default function Form({
    onSubmit,
    children,
    loading,
    submitText,
    onCancel,
    disabled,
    cancelText,
    confirmBeforeSubmit = false,
    confirmTitle = DEFAULT_CONFIRM_TITLE,
    confirmMessage = DEFAULT_CONFIRM_MESSAGE,
    confirmOkText,
    readOnly = false,
    submitGuardScope = null,
    hideActions = false,
}) {
    const [confirmOpen, setConfirmOpen] = useState(false);

    const runSubmit = () => {
        if (loading || disabled || readOnly) return;
        onSubmit?.();
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        if (loading || disabled || readOnly) return;
        if (confirmBeforeSubmit) {
            setConfirmOpen(true);
            return;
        }
        runSubmit();
    };

    const handleConfirm = () => {
        if (readOnly) return;
        setConfirmOpen(false);
        runSubmit();
    };

    const handleCloseConfirm = () => {
        if (!loading) setConfirmOpen(false);
    };

    return (
        <>
            <form className={styles.form} onSubmit={handleSubmit}>
                {children}
                {!hideActions && (
                    <HasScope scope={submitGuardScope} behavior="fallback" fallback={null}>
                        <div className={styles.formActionsWrapper}>
                            <div className={styles.formActionsSeparator} />
                            <div className={styles.formActions}>
                                <Button
                                    type="button"
                                    hierarchy={ButtonHierarchies.GHOST}
                                    disabled={loading}
                                    onClick={onCancel}
                                    className={styles.button}
                                >
                                    {cancelText ?? 'Cancel'}
                                </Button>
                                <Button
                                    type="submit"
                                    disabled={loading || disabled || readOnly}
                                    className={styles.button}
                                >
                                    {submitText ?? 'Submit'}
                                </Button>
                            </div>
                        </div>
                    </HasScope>
                )}
            </form>
            <ConfirmModal
                open={confirmOpen}
                title={confirmTitle}
                description={confirmMessage}
                onCancel={handleCloseConfirm}
                onOk={handleConfirm}
                okText={confirmOkText ?? (submitText === 'Saving...' ? 'Save' : submitText) ?? 'Save'}
                cancelText={cancelText ?? 'Cancel'}
                confirmLoading={loading}
                destroyOnHidden
            />
        </>
    );
}
